export interface Tag {
    id: string;
    name: string;
}

export default Tag;


export const dummyTags = [
    {
        "id": "addiction",
        "name": "Afhængig"
    },
    {
        "id": "divorce",
        "name": "Skilsmisse"
    },
    {
        "id": "placed",
        "name": "Anbragt"
    },
    {
        "id": "bullying",
        "name": "Mobning"
    },
    {
        "id": "mentally_vulnerable",
        "name": "Psykisk sårbar"
    },
    {
        "id": "online_identity",
        "name": "Dit liv online"
    },
    {
        "id": "violence",
        "name": "Vold og overgreb"
    },
    {
        "id": "friendship",
        "name": "Venskaber"
    },
    {
        "id": "illness",
        "name": "Sygdom"
    },
    {
        "id": "sexuality",
        "name": "Krop og seksualitet"
    },
    {
        "id": "love",
        "name": "Kærlighed"
    },
    {
        "id": "handicap",
        "name": "Handicap"
    },
    {
        "id": "work",
        "name": "Arbejde"
    },
    {
        "id": "loneliness",
        "name": "Ensomhed"
    },
    {
        "id": "school",
        "name": "Skole"
    }
]